const TEMPLATE_NAME = 'api'
let activeTags = []
var minPrice = 0
var maxPrice = undefined

var handlePriceFilter = (price) => {
  minPrice = price[0] || 0
  maxPrice = price[1]
  console.log(maxPrice)
  console.log(minPrice)
  if (maxPrice != undefined) {
    renderCollection()
  }
}

var updateActiveTags = () => {
  const selectedTags = document.querySelector('.desktop-filter').querySelectorAll('input[data-tag]:checked')
  const selectedTagButtons = document.querySelector('.desktop-filter').querySelectorAll('button.is-selected')
  activeTags = []
  selectedTags.forEach(element => {
    activeTags.push(element.getAttribute('data-tag'))
  })
  selectedTagButtons.forEach(element => {
    activeTags.push(element.getAttribute('data-tag'))
  })
  renderCollection()
}

var renderCollection = async () => {
  const partnerCollectionGridWrapper = document.querySelector('[data-section-type="partner-collection-grid"]')
  const collectionHandle = partnerCollectionGridWrapper.dataset.collectionHandle
  const html = await getCollectionHTML(collectionHandle, activeTags)
  document.querySelector('.collection__dynamic-part').innerHTML = html.querySelector('.collection__dynamic-part').innerHTML
  handleChanges();
  // Call checkForVisibleProducts after the collection is rendered
  checkForVisibleProducts()
  ratingSnippet("brand-rating", {
    store: "reboxed.co",
    mode: "default",
    color: "#2DDFAF",
    linebreak: false,
    text: "",
    singularText: "",
    lang: "en",
    usePolaris: true,
    showEmptyStars: true,
  })
}

const initFilterListener = () => {
  document.querySelectorAll('input[data-tag]').forEach(element => {
    element.addEventListener('click', () => {
      const parentFilterWrapper = element.closest('.collection__filter-group')
      let newTag = element.getAttribute('data-tag')
      parentFilterWrapper.querySelectorAll('input[data-tag]:checked').forEach(selectedElement => {
        if (newTag != selectedElement.getAttribute('data-tag')) {
          selectedElement.checked = false
        }
      })
      updateActiveTags()
    })
  })
  document.querySelectorAll('button[data-tag]').forEach(element => {
    element.addEventListener('click', () => {
      const parentFilterWrapper = element.closest('.collection__filter-group')
      if (parentFilterWrapper.querySelector('button[data-tag].is-selected') != element && parentFilterWrapper.querySelector('button[data-tag].is-selected')) {
        parentFilterWrapper.querySelector('button[data-tag].is-selected').classList.remove('is-selected')
      }
      element.classList.toggle('is-selected')
      updateActiveTags()
    })
  })
}

var getCollectionHTML = async (paramurl, param = null) => {
  let url = `${location.origin}/collections/${paramurl}?view=api`
  if (param != null) {
    let tagQuery = ''
    for (let i = 0; i < param.length; i++) {
      const tag = param[i];
      if (i != 0) {
        tagQuery += '+'
      }
      tagQuery += tag
    }
    url = `${location.origin}/collections/${paramurl}/${tagQuery}?view=api`
  }
  if (maxPrice > 0) {
    url += `&filter.v.price.gte=${minPrice}&filter.v.price.lte=${maxPrice}`
  }

  let result;
  try {
    const response = await fetch(url, {
      credentials: 'same-origin',
      method: 'GET'
    });
    const responseText = await response.text();
    result = new DOMParser().parseFromString(responseText, 'text/html');
  } catch (error) {
    console.error('Error fetching collection HTML:', error);
  }
  return result;
}

// Define your additional function
    function handleChanges() {
        document.querySelectorAll('.smarty-collection-grid input.color-swatch__radio').forEach(function(radio) {
            radio.addEventListener('change', function(e) {
                e.preventDefault();
                
                var target = this; 
                var productItem = target.closest('.product-item');
                var variantUrl = target.getAttribute('data-variant-url');
                
                productItem.querySelector('.product-item__image-wrapper').setAttribute('href', variantUrl);
                productItem.querySelector('.product-item__title').setAttribute('href', variantUrl);
    
                var originalImageElement = productItem.querySelector('.product-item__primary-image');
                
                if (target.hasAttribute('data-image-url') && target.getAttribute('data-media-id') !== originalImageElement.getAttribute('data-media-id')) {
                    var newImageElement = document.createElement('img');
                    newImageElement.className = 'product-item__primary-image lazyload image--fade-in';
                    newImageElement.setAttribute('data-media-id', target.getAttribute('data-media-id'));
                    newImageElement.setAttribute('data-src', target.getAttribute('data-image-url'));
                    newImageElement.setAttribute('data-widths', target.getAttribute('data-image-widths'));
                    newImageElement.setAttribute('data-sizes', 'auto');
                    
                    originalImageElement.parentNode.style.paddingBottom = "".concat(100.0 / newImageElement.getAttribute('data-image-aspect-ratio'), "%");
                    originalImageElement.parentNode.replaceChild(newImageElement, originalImageElement);
                }
            });
        });
    }


var mobilePartnerFilterToggle = () => {
  document.querySelector('.desktop-filter').classList.toggle('active')
}

function checkForVisibleProducts() {
  var productList = document.querySelector(".collection__dynamic-part .product-list.product-list--collection.product-list--with-sidebar");

  if (!productList) {
    return;
  }

  var childElements = Array.from(productList.children).filter(
    (child) => child.nodeType === 1
  );

  if (childElements.length === 0) {
    if (!productList.querySelector(".no-results")) {
      var noResultsMessage = document.createElement("div");
      noResultsMessage.textContent =
        "No results found. Try refining your filters";
      noResultsMessage.classList.add("no-results");
      productList.appendChild(noResultsMessage);
    }
  } else {
    let nonEmptyChildren = childElements.filter(
      (child) => child.textContent.trim() !== ""
    );

    if (nonEmptyChildren.length === 0) {
      if (!productList.querySelector(".no-results")) {
        var noResultsMessage = document.createElement("div");
        noResultsMessage.textContent =
          "No results found. Try refining your filters";
        noResultsMessage.classList.add("no-results");
        productList.appendChild(noResultsMessage);
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', async () => {
  initFilterListener()

  document.querySelectorAll('.pc-fitler-toogle-button').forEach(button => {
    button.addEventListener('click', function () {
      mobilePartnerFilterToggle()
    })
  })

  var productList = document.querySelector(
    ".collection__dynamic-part .product-list.product-list--collection.product-list--with-sidebar"
  );
  if (productList) {
    var observer = new MutationObserver(function (mutationsList, observer) {
      setTimeout(() => {
        checkForVisibleProducts();
      }, 100);
    });

    observer.observe(productList, { childList: true });
  }

  document
    .querySelectorAll(".pc-fitler-toogle-button, .filter_label, .checkbox")
    .forEach(function (element) {
      element.addEventListener("click", function () {
        setTimeout(checkForVisibleProducts, 100);
      });
    });

  checkForVisibleProducts()
});

window.addEventListener('DOMContentLoaded',function () {
  // console.log('running!!!');
    handleChanges();
});
